import { WSButton } from "@wingspanhq/fe-component-library";
import { IInvoice } from "@wingspanhq/payments/dist/interfaces";
import { useSendInvoiceReminder } from "../../../query/payments/mutations";

export const ButtonEmailClient: React.FC<{ invoice: IInvoice }> = ({
  invoice
}) => {
  const [sendReminder, sendReminderMeta] = useSendInvoiceReminder();
  return (
    <WSButton.Link
      onClick={() => {
        sendReminder({ invoice });
      }}
      loading={sendReminderMeta.isLoading}
    >
      Email client
    </WSButton.Link>
  );
};
